<template>
  <main-layout>
    <div class="liveList">
      <div class="middle container">
        <div class="offlineCourse">
          <h3 class="academyTitle">
            <!-- <a class="more" href="/academy/offlineCourse" target="_blank">{{$t('live.直播合作')}}</a> -->
            {{$t('global.直播')}}
          </h3>
          <ul class="list">
            <li v-for="item in liveList" :key="item.url">
              <a
                class="offline-course-card"
                :href="'/live/liveDetail?id=' + item.id"
                target="_blank;"
              >
                <div class="left">
                  <span
                    class="status status-notstarted"
                    v-if="item.liveStatus == 2"
                  >{{$t('live.即将开始')}}</span>
                  <span class="status status-living" v-if="item.liveStatus == 1">
                    <img src="/static/icon_app_live_on_white.gif" alt />
                    {{$t('live.直播中')}}
                  </span>
                  <span
                    class="status status-closed"
                    v-if="item.liveStatus == 3"
                  >{{$t('global.已结束')}}</span>
                  <img :src="item.horizontalThumb | imageUrl('https://image.manamana.net/1641283406000_WOWHgtGT',700,394)" />
                  <div class="popIntroduction">
                    <p class="introduction">{{item.intro}}</p>
                  </div>
                </div>
                <div class="right">
                  <h5>{{item.title}}</h5>
                  <div class="sub-title">
                    <div class="guest" v-for="(index,y) in item.guestForms" :key="y">
                      <router-link
                        :to="'/peopleCenter/'+ index.userId +  '/home'"
                        v-if="index.userId"
                        target="_blank"
                      >{{index.nickName}}</router-link>
                      <span v-if="!index.userId">{{index.nickName}}</span>
                      <i></i>
                    </div>
                  </div>
                  <p class="begin-time">{{formatDate(item.liveStartTime, 1)}}</p>
                  <p class="info">
                    <span v-if="item.price > 0" class="price">
                      ￥<b>{{item.price}}</b>
                    </span>
                    <span v-if="item.price == 0 || item.price == null" class="free">
                      <b>{{$t('global.免费')}}</b>
                    </span>
                  </p>
                  <div v-if="item.liveStatus == 2">
                    <span
                      class="liveStatus status_4"
                      @click.stop.prevent="closeSub(item.id)"
                      v-if="item.isSub"
                    >
                      <i class="hover1">{{$t('live.已订阅')}}</i>
                      <i class="hover2">{{$t('live.取消订阅')}}</i>
                    </span>
                    <el-popover placement="bottom" width="175px" trigger="hover" v-else>
                      <div class="tixing">{{$t('live.开播前短信/服务号/App通知')}}</div>
                      <span
                        class="liveStatus status_1"
                        slot="reference"
                        @click.stop.prevent="subscribe(item.id)"
                      >
                        <img src="/static/web_live_notif_icon@2x.png" alt />
                        {{$t('live.订阅')}}
                      </span>
                    </el-popover>
                  </div>
                  <span
                    class="liveStatus status_2"
                    v-if="item.liveStatus == 1"
                    @click.stop.prevent="gotolivePage(item.activityId)"
                  >{{$t('live.进入直播间')}}</span>
                  <span
                    class="liveStatus status_3"
                    @click.stop.prevent="gotolivePage(item)"
                    v-if="item.liveStatus == 3"
                  >{{$t('live.进入回看')}}</span>
                </div>
              </a>
            </li>
          </ul>
        </div>
        <pagination
          :totalRecord="pagerParams.total"
          :pageSize="pagerParams.pageSize"
          :pageIndex="pagerParams.pageIndex"
          @OnCurrentChanged="OnCurrentPageChanged"
        />
        <div class="popup" v-if="isPopupShow">
          <div class="popupBox" v-if="subTer">
            <p class="title">
              {{$t('live.订阅直播')}}
              <span @click="closePopup"></span>
            </p>
            <p class="line"></p>
            <img class="subImg" src="/static/img_subscribed@2x.png" alt />
            <p class="text">{{$t('live.您已成功订阅直播提醒，直播开始前15分钟将通过短信、服务号及App推送通知。')}}</p>
          </div>
          <div class="popupBox" v-else>
            <p class="title">
              {{$t('live.取消订阅成功')}}
              <span @click="closePopup"></span>
            </p>
            <p class="line"></p>
            <img class="subImg" src="/static/img_unsubscribed@2x.png" alt />
            <p class="text">{{$t('live.您已成功取消订阅直播提醒，将不再收到该直播开始的通知。')}}</p>
          </div>
        </div>
      </div>
    </div>
  </main-layout>
</template>

<script>
import MainLayout from "@/layouts/MainLayout";
import item from "../../components/item.vue";
import FilterTable from "../../components/FilterTable.vue";
import Pagination from "@/components/v2/Pagination";

export default {
  name: "ExploreSubject",
  metaInfo() {
    return {
      title: "MANA " + this.$t("global.直播")
    };
  },
  components: {
    MainLayout,
    item,
    FilterTable,
    Pagination
  },
  data() {
    return {
      liveList: [],
      selectedFilters: [],
      filterList: [],
      industryId: "",
      professionId: "",
      orderByType: 0,
      videoList: [],
      isLogin: localStorage.getItem("auth_token") !== null,
      pagerParams: {
        pageSize: 12,
        pageCount: 1,
        pageIndex: 1,
        total: 0
      },
      isPopupShow: false,
      subTer: true
    };
  },
  created() {
    this.getLiveList();
    this.buriedPoint(49,0)
  },
  methods: {
    OnCurrentPageChanged(val) {
      this.pagerParams.pageIndex = val;
      this.getLiveList();
    },
    gotolivePage(item) {
      if (item.videoId) {
        let routeData = this.$router.resolve({ path: "/video/detail?id=" + item.videoId });
        window.open(routeData.href, "_blank");
      } else if (item.activityId){
        let routeData = this.$router.resolve({ path: "/live/livePage?id=" + item.activityId });
        window.open(routeData.href, "_blank");
      }
    },
    subscribe(id) {
      this.subTer = true;
      this.$http.get("/api/bytedance/sub/" + id).then(res => {
        if (res.code === "OK") {
          document.body.style.overflow = "hidden";
          this.isPopupShow = true;
          this.getLiveList();
        }
      });
    },
    closeSub(id) {
      this.subTer = false;
      this.$http.get("/api/bytedance/unsub/" + id).then(res => {
        if (res.code === "OK") {
          document.body.style.overflow = "hidden";
          this.isPopupShow = true;
          this.getLiveList();
        }
      });
    },
    closePopup() {
      document.body.style.overflow = "";
      this.isPopupShow = false;
    },
    getLiveList() {
      this.$http
        .get("/api/bytedance/", {
          params: {
            pageIndex: this.pagerParams.pageIndex,
            pageSize: this.pagerParams.pageSize
          }
        })
        .then(res => {
          if (res.code === "OK") {
            this.liveList = res.data.list;
            this.pagerParams.total = res.data.totalRecord;
          }
        });
    }
  },
  watch: {}
};
</script>

<style lang="stylus" scoped>
.liveList {
  background: #fff;
  padding-bottom: 20px;

  .container {
    width: 1110px;
  }
}

.academyTitle {
  padding: 70px 0;
  font-size: 44px;

  .more {
    float: right;
    margin-top: 20px;
    font-size: 20px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #2026CC;

    &:hover {
      color: #1C21B0;
    }
  }
}

.top {
  padding-top: 0.6rem;
}

.offlineCourse {
  overflow: hidden;

  .list {
    li {
      float: left;
      width: 350px;
      margin: 0 30px 60px 0;
      height: 362px;
      border: 1px solid rgba(224, 224, 224, 1);
      box-sizing: border-box;
      overflow: hidden;

      .offline-course-card {
        display: block;
        position: relative;
        background: #fff;

        .left {
          position: relative;
          width: 100%;
          height: 197px;

          img {
            width: 100%;
            height: 197px;
          }

          .popIntroduction {
            positioN: absolute;
            left: 0;
            top: 0;
            width: 100%;
            height: 100%;
            background: rgba(10, 10, 10, 0.7);
            display: none;

            .introduction {
              position: absolute;
              max-height: 60px;
              font-size: 13px;
              font-family: NunitoSans-Regular, NunitoSans;
              font-weight: 400;
              color: rgba(255, 255, 255, 1);
              line-height: 20px;
              width: 100%;
              padding: 0 20px;
              box-sizing: border-box;
              left: 0;
              bottom: 50px;
              overflow: hidden;
              text-overflow: ellipsis;
              display: -webkit-box;
              word-break: break-word;
              -webkit-box-orient: vertical;
              -webkit-line-clamp: 3;
            }
          }

          .status {
            position: absolute;
            bottom: 0;
            left: 0;
            padding: 0 12px;
            height: 24px;
            line-height: 24px;
            text-align: center;
            background-size: 100%;
            font-size: 13px;
            font-weight: 400;
            color: rgba(255, 255, 255, 1);
            z-index: 111;
            border-radius: 0px 4px 0px 0px;
          }

          .status-notstarted {
            background: linear-gradient(135deg, rgba(54, 100, 237, 0.9) 0%, rgba(32, 38, 204, 0.9) 100%);
          }

          .status-living {
            background: linear-gradient(135deg, rgba(254, 161, 116, 0.9) 0%, rgba(254, 86, 48, 0.9) 100%);

            img {
              display: inline-block;
              width: 18px;
              height: 18px;
              vertical-align: text-top;
              margin-right: 4px;
            }
          }

          .status-closed {
            background: linear-gradient(135deg, rgba(204, 204, 204, 0.9) 0%, rgba(153, 153, 153, 0.9) 100%);
          }
        }

        .right {
          height: 165px;
          padding: 12px 20px 20px;
          box-sizing: border-box;

          h5 {
            text-overflow: -o-ellipsis-lastline;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2;
            height: 42px;
            font-size: 15px;
            font-family: PingFangSC-Semibold, PingFang SC;
            font-weight: 600;
            color: rgba(10, 10, 10, 1);
            line-height: 21px;
            word-break: break-word;
          }

          .sub-title {
            height: 18px;
            font-size: 13px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: rgba(102, 102, 102, 1);
            line-height: 18px;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            margin-top: 10px;

            .guest {
              display: inline;

              &:last-child {
                i {
                  display: none;
                }
              }

              a {
                color: #666;

                &:hover {
                  color: #0A0A0A;
                }
              }

              span {
                color: #999;
              }

              i {
                background: rgba(184, 184, 184, 1);
                display: inline-block;
                width: 3px;
                height: 3px;
                margin-right: 3px;
                border-radius: 50%;
                vertical-align: middle;
              }
            }
          }

          .begin-time {
            margin-top: 12px;
            font-size: 13px;
            font-family: NunitoSans-Regular, NunitoSans;
            font-weight: 400;
            color: rgba(102, 102, 102, 1);
          }

          .begin-time-expired {
            color: #999;
          }

          .info {
            margin-top: 10px;
            font-size: 16px;
            font-family: PingFangSC-Semibold, PingFang SC;
            color: rgba(252, 98, 64, 1);

            .price {
              font-weight: 400;
              font-size: 16px;
              b{
                font-weight: 600;
              }
            }

            .free {
              font-weight: 600;
              font-size: 16px;
            }
          }

          .btn-wrap {
            position: absolute;
            right: 0;
            bottom: 0;
            text-align: right;

            .btn {
              display: inline-block;
              width: 90px;
              height: 34px;
              background: #3664ED;
              color: #fff;
              font-size: 16px;
              font-weight: bold;
              text-align: center;
              line-height: 34px;
              border-radius: 20px;
            }

            .btn-disable {
              background: #eee;
              color: #999;
            }
          }

          .liveStatus {
            position: absolute;
            right: 20px;
            bottom: 20px;
            height: 28px;
            line-height: 28px;
            min-width: 108px;
            text-align: center;
          }

          .status_1 {
            min-width: 88px;
            border: 1px solid rgba(32, 38, 204, 1);
            font-size: 14px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: rgba(32, 38, 204, 1);

            img {
              display: inline-block;
              width: 14px;
              height: 14px;
              vertical-align: middle;
              margin-right: 5px;
            }
          }

          .status_2, .status_3 {
            border: 1px solid rgba(32, 38, 204, 1);
            font-size: 14px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: rgba(32, 38, 204, 1);

            img {
              display: inline-block;
              width: 10px;
              height: 16px;
              vertical-align: middle;
              margin-left: 5px;
            }
          }

          .status_4 {
            min-width: 90px;
            border: 1px solid rgba(184, 184, 184, 1);
            font-size: 14px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: rgba(184, 184, 184, 1);
            &:hover{
              color:rgba(153,153,153,1);
              border:1px solid rgba(153,153,153,1);
            }
            .hover2 {
              display: none;
            }

            &:hover .hover2 {
              display: block;
            }

            &:hover .hover1 {
              display: none;
            }
          }
        }
      }

      &:hover {
        box-shadow: 0px 2px 20px 0px rgba(0, 0, 0, 0.1);

        .offline-course-card .left .popIntroduction {
          display: block;
        }
      }

      &:nth-child(3n) {
        margin-right: 0;
      }
    }
  }
}

.top-filter {
  color: #000;
  -webkit-border-radius: 8px;
  -moz-border-radius: 8px;
  border-radius: 8px;
  overflow: hidden;
  zoom: 1;
  background: #fff;
}

.top-tabs {
  width: 140px;
  float: left;
  font-size: 0.26rem;
}

.top-tab {
  height: 0.87rem;
  line-height: 0.87rem;
  text-align: center;
  background-color: #fbfbfb;
  cursor: pointer;
  color: #999;
}

.top-tab.active {
  background-color: #fff;
  color: #333333;
}

.top-tab-contents {
  width: 1020px;
  float: left;
}

.filter-result {
  margin-top: 0.2rem;
  text-align: center;
}

.filter-result .pre {
  margin-right: 0.4rem;
}

.filter-result .el-button {
  color: #0060ff;
  border-color: #dcdfe6 !important;
}

.filter-result .el-button-group {
  margin-right: 0.2rem;
}

.orderby {
  margin: 0 0 20px;
  line-height: 0.16rem;
  color: #777777;
  font-size: 0.16rem;
}

.orderby .add {
  float: right;
  color: #0060ff;
}

.orderby > label {
  display: inline-block;
  margin-right: 0.3rem;
}

.orderby .active {
  color: #0060ff;
}

.orderby label {
  cursor: pointer;
}

.orderby-icon-time {
  display: inline-block;
  width: 0.16rem;
  height: 0.16rem;
  background: url('/static/explore/time.png') no-repeat center center;
  background-size: contain;
  vertical-align: bottom;
}

.orderby-icon-visit {
  display: inline-block;
  width: 0.19rem;
  height: 0.16rem;
  background: url('/static/explore/visit.png') no-repeat center center;
  background-size: contain;
  vertical-align: bottom;
  margin-right: 0.1rem;
  margin-left: 0.35rem;
}

.orderby-icon-zan {
  display: inline-block;
  width: 0.16rem;
  height: 0.16rem;
  background: url('/static/explore/zan.png') no-repeat center center;
  background-size: contain;
  vertical-align: bottom;
  margin-right: 0.1rem;
  margin-left: 0.35rem;
}

.orderby-icon-comment {
  display: inline-block;
  width: 0.16rem;
  height: 0.16rem;
  background: url('/static/explore/comment.png') no-repeat center center;
  background-size: contain;
  vertical-align: bottom;
  margin-right: 0.1rem;
  margin-left: 0.35rem;
}

.vedio-list .el-row {
  margin: 0 -0.13rem;
}

.vedio-list .item {
  margin: 0.13rem;
  cursor: pointer;
}

.author-item {
  overflow: hidden;
  zoom: 1;
  border-bottom: 1px solid #dddddd;
  padding: 0.4rem 0;
}

.author-info {
  float: left;
  width: 7.46rem;
  overflow: hidden;
  zoom: 1;
}

.author-avatar {
  width: 1.3rem;
  height: 1.3rem;
  float: left;
  display: block;
  -webkit-border-radius: 50%;
  -moz-border-radius: 50%;
  border-radius: 50%;
}

.author-content {
  width: 6.13rem;
  float: left;
  padding-left: 0.3rem;
  padding-top: 0.07rem;
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
}

.author-name {
  font-size: 0.26rem;
  color: #333333;
}

.author-title {
  font-size: 0.16rem;
  color: #777777;
  margin: 0.1rem 0 0.2rem;
}

.author-focus {
  display: block;
  width: 1.2rem;
  height: 0.4rem;
  line-height: 0.4rem;
  padding: 0;
  font-size: 0.16rem;
  color: #fff;
  text-align: center;
  background-color: #0060ff;
  -webkit-border-radius: 0.2rem;
  -moz-border-radius: 0.2rem;
  border-radius: 0.2rem;
}

.author-vedio {
  float: right;
  width: 8.6rem;
  margin: 0.07rem -0.05rem 0;
  overflow: hidden;
  zoom: 1;
  position: relative;
}

.author-vedio-item {
  width: 25%;
  float: left;
  padding: 0 0.05rem;
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
}

.author-vedio-item img {
  width: 2.06rem;
  height: 1.16rem;
  display: block;
  margin: 0 auto;
}

.orderby-icon-user {
  display: inline-block;
  width: 0.16rem;
  height: 0.17rem;
  background: url('/static/explore/user.png') no-repeat center center;
  background-size: contain;
  vertical-align: bottom;
  margin-right: 0.1rem;
}

.orderby-icon-vedio {
  display: inline-block;
  width: 0.16rem;
  height: 0.17rem;
  background: url('/static/explore/vediocount.png') no-repeat center center;
  background-size: contain;
  vertical-align: bottom;
  margin-right: 0.1rem;
  font-size: 0.26rem;
}

.orderby .active-time {
  background: url('/static/explore/focusTime.png') no-repeat center center;
  background-size: contain;
}

.orderby .active-user {
  background: url('/static/explore/focusUser.png') no-repeat center center;
  background-size: contain;
}

.orderby .active-video {
  background: url('/static/explore/focusVideo.png') no-repeat center center;
  background-size: contain;
}

.subject-list {
  margin: 0 auto;
  overflow: hidden;
  zoom: 1;
}

.subject-item {
  cursor: pointer;
  display: block;
  float: left;
  width: 565px;
  margin: 0 30px 30px 0;
  -webkit-border-radius: 6px;
  -moz-border-radius: 6px;
  border-radius: 6px;
  background-color: #fff;
  overflow: hidden;
  position: relative;
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
  -webkit-box-shadow: 2px 2px 2px #eaeaea;
  -moz-box-shadow: 2px 2px 2px #eaeaea;
  box-shadow: 2px 2px 2px #eaeaea;
}

.subject-item:nth-child(2n) {
  margin-right: 0;
}

.subject-add {
  cursor: pointer;
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
  text-align: center;
  font-size: 0.22rem;
  color: #333333;
  padding: 0;
}

.subject-add:before {
  content: '';
  display: block;
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
  width: 7.8rem;
  height: 100px;
  position: absolute;
  left: 0.1rem;
  top: 0.1rem;
  border: 2px dotted #e1e1e1;
  -webkit-border-radius: 6px;
  -moz-border-radius: 6px;
  border-radius: 6px;
}

.subject-add:after {
  content: '';
  display: block;
  width: 0.8rem;
  height: 0.8rem;
  background: url('/static/explore/add.png') no-repeat center center;
  background-size: contain;
  position: absolute;
  left: 1.5rem;
  top: 1.5rem;
}

.subject-img {
  display: block;
  height: 161px;
  width: 565px;
}

.subject-content {
  padding: 20px;
}

.subject-title {
  font-size: 20px;
  color: #333;
  font-weight: bold;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.subject-summary {
  height: 40px;
  margin-top: 10px;
  font-size: 14px;
  color: #999;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  /* autoprefixer: off */
  -webkit-box-orient: vertical;
  /* autoprefixer: on */
  word-break: break-word;
}

.subject-count {
  margin-top: 15px;
  font-size: 12px;
  color: #999;
}

.subject-count span {
  margin-right: 10px;
}

.subject-count span i {
  color: #333;
}

.popup {
  position: fixed;
  width: 100%;
  height: 100vh;
  left: 0;
  top: 0;
  background: rgba(0, 0, 0, 0.4);
  z-index: 9999;

  .popupBox {
    width: 380px;
    height: 240px;
    background: rgba(255, 255, 255, 1);
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);

    .title {
      font-size: 16px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: rgba(51, 51, 51, 1);
      height: 60px;
      line-height: 60px;
      padding: 0 20px;
      position: relative;

      span {
        background: url('/static/close_btn@2x.png');
        background-size: 100%;
        width: 13px;
        height: 13px;
        position: absolute;
        right: 20px;
        top: 23px;
        cursor: pointer;
      }
    }

    .line {
      height: 1px;
      width: 100%;
      background: #E0E0E0;
    }

    .subImg {
      display: inline-block;
      width: 64px;
      height: 64px;
      margin: 15px 158px;
    }

    .text {
      height: 48px;
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: rgba(102, 102, 102, 1);
      line-height: 24px;
      padding: 0 20px;
      text-align: center;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/newLive/list.vue